/* eslint-disable @typescript-eslint/no-explicit-any */
export const key_exists = (obj: any, path: any) => {
    const keys = path.split('.')

    const keyExists = function (obj: any, keyList: any): boolean {
        const cur = keyList.shift()
        if (obj.hasOwnProperty(cur)) {
            if (keyList.length <= 0) {
                return true
            } else {
                return keyExists(obj[cur], keyList)
            }
        } else {
            return false
        }
    }
    if (obj && typeof obj == 'object' && keys.length > 0) {
        return keyExists(obj, keys)
    } else {
        return false
    }
}
